import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import { Toaster } from "sonner";

import Layout from "@/components/Layout";
import ScrollToTop from "@/components/ScrollToTop";
import TrackingScripts from "@/components/TrackingScripts";
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import ServicesPage from "@/pages/ServicesPage";
import ContactPage from "@/pages/ContactPage";
import AdminPage from "@/pages/AdminPage";
import LandingPage from "@/pages/LandingPage";
import ThankYouPage from "@/pages/ThankYouPage";
import CoachesLandingPage from "@/pages/CoachesLandingPage";
import BookingPage from "@/pages/BookingPage";
import BookingCancelPage from "@/pages/BookingCancelPage";
import BookingConfirmedPage from "@/pages/BookingConfirmedPage";
import WatchPage from "@/pages/WatchPage";
import VSLQualifyPage from "@/pages/VSLQualifyPage";
import VSLVideoPage from "@/pages/VSLVideoPage";
import ForCoachesPage from "@/pages/ForCoachesPage";
import WebinarLandingPage from "@/pages/WebinarLandingPage";
import WebinarConfirmedPage from "@/pages/WebinarConfirmedPage";
import DigitalSalesEnginePage from "@/pages/DigitalSalesEnginePage";
import PersonalBrandingPage from "@/pages/PersonalBrandingPage";
import StrategyCallPage from "@/pages/StrategyCallPage";

function AnimatedRoutes() {
  const location = useLocation();
  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/personal-branding" element={<LandingPage />} />
        <Route path="/coaches" element={<CoachesLandingPage />} />
        <Route path="/book" element={<BookingPage />} />
        <Route path="/verify-your-eligibility" element={<StrategyCallPage />} />
        <Route path="/strategy-call" element={<Navigate to="/verify-your-eligibility" replace />} />
        <Route path="/book/cancel" element={<BookingCancelPage />} />
        <Route path="/confirmed" element={<BookingConfirmedPage />} />
        <Route path="/watch/:code" element={<WatchPage />} />
        <Route path="/vsl" element={<VSLQualifyPage />} />
        <Route path="/vsl/video" element={<VSLVideoPage />} />
        <Route path="/for-coaches" element={<ForCoachesPage />} />
        <Route path="/webinar" element={<WebinarLandingPage />} />
        <Route path="/webinar/confirmed" element={<WebinarConfirmedPage />} />
        <Route path="/thankyou" element={<ThankYouPage />} />
        <Route element={<Layout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/services/digital-sales-engine" element={<DigitalSalesEnginePage />} />
          <Route path="/services/personal-branding" element={<PersonalBrandingPage />} />
          <Route path="/contact" element={<ContactPage />} />
        </Route>
      </Routes>
    </AnimatePresence>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <TrackingScripts />
        <AnimatedRoutes />
        <Toaster
          theme="dark"
          position="bottom-right"
          toastOptions={{
            style: {
              background: "#111",
              border: "1px solid rgba(217,4,41,0.3)",
              color: "#fafafa",
              fontFamily: "Outfit, sans-serif",
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
